import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Stamps the client's IANA timezone id (e.g. "America/New_York") onto every
 * request via the `X-Time-Zone` header. The reports API reads this header to
 * render downloaded reports in the user's local time; when it is missing the
 * backend falls back to Central time (America/Mexico_City).
 */
@Injectable()
export class TimeZoneInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (timeZone) {
      request = request.clone({ setHeaders: { 'X-Time-Zone': timeZone } });
    }

    return next.handle(request);
  }
}
